import React,{useEffect, useState,Fragment} from 'react';
import List from '@material-ui/core/List';
import axios from 'axios';
import {uri}  from '../../help/Api';
import {insh, sto} from '../../Context/InshData';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Switch from '@material-ui/core/Switch';
import BallotIcon from '@material-ui/icons/Ballot';
import LineStyleIcon from '@material-ui/icons/LineStyle';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

import {useStylesSetting,} from '../../St/comps/UseStyle';
import { useTranslation } from "react-i18next";

export default function PermisionsApp() {
  const { t } = useTranslation(["forms", "translation"]);
  const clasStt = useStylesSetting();
  const [showSc, setShowSc] = useState(false);
  const [permissionApp, setPermissionApp] = useState(insh.PermissionApp);
  useEffect(() => {
    // getS
   },[]);

  const storgeing = async (info) => {

   const tb = { PermissionApp:true, wait:true,
    /*params*/
    parms:{
      iuserid:info.user_id, 
      db_name:sto.db_name
    },
    autos:{},
  }
   await axios.post(uri+'Res',tb)
    .then(res => { 
    localStorage.setItem('premiApp', JSON.stringify(res.data.permisApp));
    setPermissionApp(res.data.permisApp)
    setShowSc(res.data.wait.state)
  }).catch(error => { 
    // console.log('nooooo sttorgeing'); 
  })
  
  }

  const updatePrem = async (prop,event) => {
   if(prop=='') permissionApp.menuMin=event.target.checked;
   else if(prop=='showCurr') permissionApp.showCurr=event.target.checked;

    await  axios.put(uri+'PermissionApp', {...permissionApp,db_name:sto?.db_name})
    .then(res => {setShowSc(true); storgeing(res.data) }).catch(error => { })
  }

  return (
    <Fragment> 
       <Container maxWidth="md">
      <Typography component="div" style={{ backgroundColor: '#f5f5f5b5', height: '100vh' }}>
        <Grid container md={12} className={clasStt.rootSett}>
          <List subheader={<ListSubheader className={clasStt.titleSett}>{t("items-settings")}</ListSubheader>} className={clasStt.rootSett}>
           <ListItem>
              <ListItemIcon> <LineStyleIcon /> </ListItemIcon>
              {permissionApp.showCurr === true
              ?<ListItemText id="switch-list-label-wi" className={clasStt.itemText} secondary={t("activated")} primary={t("items-display-mode")} />
              :<ListItemText id="switch-list-label-w" className={clasStt.itemText} secondary={t("toggle-show-as-images")} primary={t("items-display-mode")} />
              }
              <ListItemSecondaryAction>
                <Switch edge="end" onChange={e=> updatePrem('showCurr',e)} checked={permissionApp.showCurr}
                  inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} name="curr" />
              </ListItemSecondaryAction>
            </ListItem>
          </List>

          <List subheader={<ListSubheader className={clasStt.titleSett}>{t("main-ui-settings")}</ListSubheader>} className={clasStt.rootSett}>
            <ListItem>
              <ListItemIcon> <BallotIcon /> </ListItemIcon>
            {permissionApp.menuMin 
              ?<ListItemText id="switch-list-label-wifi" className={clasStt.itemText} secondary={t("activated")} primary={t("main-ui-display-mode")} />
              :<ListItemText id="switch-list-label-wifi" className={clasStt.itemText} secondary={t("toggle-system-layout")} primary={t("main-ui-display-mode")} />
            }
                <ListItemSecondaryAction>
                  <Switch edge="end" onChange={e=> updatePrem('menuMin',e)} checked={permissionApp.menuMin }
                    inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} name="sett" />
                </ListItemSecondaryAction>
           </ListItem>
          </List>

        </Grid>
      </Typography>
    </Container>
    </Fragment>
  );
}



    //  <ListItem>
    //     <ListItemIcon>
    //       <BluetoothIcon />
    //     </ListItemIcon>
    //     <ListItemText id="switch-list-label-bluetooth" primary="Bluetooth" />
    //     <ListItemSecondaryAction>
    //       <Switch
    //         edge="end"
    //         onChange={handleToggle('bluetooth')}
    //         checked={checked.indexOf('bluetooth') !== -1}
    //         inputProps={{ 'aria-labelledby': 'switch-list-label-bluetooth' }}
    //       />
    //     </ListItemSecondaryAction>
    //   </ListItem> 
